/*
  Kargo sigortası Alpine store'u.

  NEDEN DEĞİŞTİ (30.09.2026): Sepete Ekle'ye her basıldığında konsola
  "TypeError: Cannot read properties of undefined (reading 'openInsuranceNoti')"
  düşüyordu. MIDA bu tıklamaları error-click sayıp G2/G3/G5 metriklerini
  şişiriyordu (28.09.2026 ölçümü: Sepete Ekle 100 görüntülemede 8,3 -> 17,5).

  İki ayrı yarış koşulu vardı:

  1) Dosyanın ilk satırı `window.Eurus.loadedScript` okuyordu. Eurus henüz
     tanımlı değilse script daha ilk satırda ölüyor ve store HİÇ kaydolmuyordu.
  2) Kayıt `requestAnimationFrame` içinde `alpine:init` dinleyicisine
     bağlanıyordu. Alpine bu temada ilk kullanıcı etkileşiminde yükleniyor;
     araya giren bir kare yüzünden dinleyici olayı kaçırabiliyordu.

  Store kaydolmayınca snippets/cart-drawer.liquid'deki DOKUZ ayrı
  `$store.xPopupInsurance...` ifadesi hata fırlatıyor. Davranış değişmiyor;
  yalnız kaydın her durumda yapılması garanti altına alınıyor.
*/
(function () {
  var ad = 'product-insurance.js';

  // Eurus yoksa da çalış: yükleme kaydı varsa kullan, yoksa kendi bayrağımızı koy.
  var kayitli = window.Eurus && window.Eurus.loadedScript;
  if (kayitli) {
    if (window.Eurus.loadedScript.has(ad)) return;
    window.Eurus.loadedScript.add(ad);
  } else {
    if (window.__alixSigortaKuruldu) return;
    window.__alixSigortaKuruldu = true;
  }

  function storeKur() {
    if (!window.Alpine || typeof window.Alpine.store !== 'function') return;
    // Aynı store iki kez kurulmasın.
    try { if (window.Alpine.store('xPopupInsurance')) return; } catch (e) {}

    window.Alpine.store('xPopupInsurance', {
      open: false,
      loading: false,
      openInsuranceNoti: false,
      openInsuranceNotification: function () {
        var self = this;
        self.openInsuranceNoti = true;
        setTimeout(function () { self.openInsuranceNoti = false; }, 5000);
      }
    });
  }

  // Alpine zaten başlamışsa doğrudan kur; başlamamışsa olayını bekle.
  if (window.Alpine && typeof window.Alpine.store === 'function') storeKur();
  document.addEventListener('alpine:init', storeKur);
})();
